import * as React from 'react';

// eslint-disable-next-line react/display-name
export const CustomInput = React.forwardRef(({ value, onClick, disabled }: any, reference: any) => (
  <button type='button' className='btn header-button' onClick={onClick} ref={reference} disabled={disabled}>
    {value || '-----'}
  </button>
));
